module.exports = __webpack_public_path__ + "img/21.b547b94a.svg";